package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class AdminTargetType(val value: String) {
    @SerialName("user") USER("user"),
    @SerialName("listing") LISTING("listing");

    companion object {
        fun fromDbValue(dbValue: String): AdminTargetType =
            entries.find { it.value == dbValue.lowercase() } ?: USER
    }
}
